angular.module("componentes").directive("loginOptions", [
	"$timeout",
	function ($timeout) {
		"use strict";
		return {
			scope: {},
			controller: "LoginOptionsCtrl",
			controllerAs: "ctrl",
			templateUrl: "views/login/components/loginOptions_template.html"
		};
	}
]);
